import type { Duration } from 'date-fns'

export function getPartnerDuration(durationMinutes: number): Duration {
  const hours = Math.floor(durationMinutes / 60)
  const minutes = durationMinutes % 60

  return {
    hours: hours || undefined,
    minutes: minutes || (hours === 0 ? 0 : undefined),
  }
}
